import { render, staticRenderFns } from "./r-item-merge-config.vue?vue&type=template&id=a99f8a44"
import script from "./r-item-merge-config.vue?vue&type=script&lang=js"
export * from "./r-item-merge-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a99f8a44')) {
      api.createRecord('a99f8a44', component.options)
    } else {
      api.reload('a99f8a44', component.options)
    }
    module.hot.accept("./r-item-merge-config.vue?vue&type=template&id=a99f8a44", function () {
      api.rerender('a99f8a44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/merge/r-item-merge-config.vue"
export default component.exports